<!--
 * @Author: zhaoliang
 * @Date: 2024-06-14 16:56:53
 * @LastEditTime: 2024-08-13 10:59:51
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/PrebookBanner/index.vue
 *
-->
<template>
  <section class="wrapper">
    <div class="content">
      <img src="~img/Shape.png" class="go-back-icon" @click="goBack" role="go back" />
    </div>
    <img src="~img/prebook-lounge-icon.svg" alt="" class="logo" />
    <h1 class="title">{{ $t('prebook-banner-title') }}</h1>
    <p class="desc">{{ $t('prebook-banner-subtitle') }}</p>
    <div class="line"></div>
    <div class="content">
      {{ $t('prebook-banner-content-1') }}
      <!-- We are excited to introduce our pre-booking functionality at participating lounges to enhance
      your travel experience. This feature allows you to reserve access to airport lounges up to 48
      hours before your trip, providing you with a relaxing start to your journey. -->
    </div>
    <div class="content">
      {{ $t('prebook-banner-content-2') }}
      <!-- Whether you’re travelling for business or pleasure, you can now reserve a spot in one of our
      participating lounges before you arrive at the airport. -->
    </div>
    <div class="content">
      {{ $t('prebook-banner-content-3') }}
      <!-- Pre-booking a lounge visit is simple to use: -->
    </div>
    <div class="content">
      <ul>
        <li>
          {{ $t('prebook-banner-content-4') }}
          <!-- 1. Find a participating lounge -->
        </li>
        <li>
          {{ $t('prebook-banner-content-5') }}
          <!-- 2. Select the pre-book option -->
        </li>
        <li>
          {{ $t('prebook-banner-content-6') }}
          <!-- 3. Schedule your preferred slot -->
        </li>
        <li>
          {{ $t('prebook-banner-content-7') }}
          <!-- 4. Complete the booking -->
        </li>
      </ul>
    </div>
    <div class="content">
      {{ $t('prebook-banner-content-8') }}
      <!-- The lounge pre-booking option is designed to provide you with a seamless travel experience,
      allowing you to relax and recharge before your flight. -->
    </div>
    <div class="content">
      <div class="btn" @click="goToLounge">
        {{ $t('prebook-banner-content-9') }}
        <!-- Explore lounges -->
      </div>
    </div>
  </section>
</template>
<script>
  import i18n from '@/i18n';
  export default {
    data() {
      return {
        i18n,
      };
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      goToLounge() {
        this.$router.push({ path: '/lounges' });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 65px;
    margin-bottom: 50px;

    .go-back-icon {
      width: 15px;
      height: 25px;
      cursor: pointer;
    }

    .logo {
      width: 191px;
      height: 180px;
      margin-bottom: 50px;
    }

    .title {
      @include font(36px, 600);
      margin-bottom: 15px;
    }

    .desc {
      @include font(28px, 400);
      margin-bottom: 45px;
    }

    .line {
      width: 100px;
      height: 0px;
      border: 2px solid #c29d5c;
      margin-bottom: 35px;
    }

    .content {
      width: 65%;
      @include font(20px, 400);
      line-height: 30px;
      margin-bottom: 20px;
    }

    .btn {
      @include main-btn();
      width: 300px;
    }
  }

  @media screen and (max-width: 1024px) {
    .wrapper {
      width: 100%;
      padding: 0px 20px;
      margin-top: 35px;
      margin-bottom: 20px;

      .go-back-icon {
        width: 12px;
        height: 20px;
        cursor: pointer;
      }

      .logo {
        width: 110px;
        height: 100px;
        margin-bottom: 20px;
      }

      .title {
        @include font(20px, 700);
        margin-bottom: 10px;
      }

      .desc {
        @include font(16px, 400);
        margin-bottom: 20px;
      }

      .line {
        width: 100px;
        height: 0px;
        border: 2px solid #c29d5c;
        margin-bottom: 20px;
      }

      .content {
        width: 100%;
        @include font(14px, 400);
        line-height: 20px;
        margin-bottom: 15px;
      }

      .btn {
        width: 100%;
      }
    }
  }
</style>
